import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { colourStyles } from 'utils/selectStyle'

const CustomCompanySelect = ({ onChange, token, translate, value, excludeInactive }) => {
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(false)

  const mapCompanies = (company) => ({
    value: company.id,
    label: `${company.id} - ${company.name}`,
  })

  useEffect(() => {
    const fetchCompanies = async () => {
      setLoading(true)

      const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
      await new Api(token)
        .post(endpoint)
        .then((response) => {
          response.data.push({
            id: '0999',
            name: translate('analytics.matrix.name'),
          })
          setCompanies(response.data.map(mapCompanies))
        })
        .catch(() => setCompanies([]))
        .finally(() => setLoading(false))
    }

    fetchCompanies()
  }, [])

  return (
    <Select
      className='custom-select'
      classNamePrefix='custom-select'
      isClearable
      onChange={(option) => onChange(option || {})}
      options={companies}
      placeholder={translate(
        loading ? 'ruptures.loading' : 'ruptures.idBranch'
      )}
      styles={colourStyles}
      value={
        companies && value
          ? companies.find((option) => option.value === value)
          : null
      }
    />
  )
}

CustomCompanySelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  token: PropTypes.string,
  translate: PropTypes.func.isRequired,
  value: PropTypes.string,
  excludeInactive: PropTypes.bool,
}

export default CustomCompanySelect
